<template>
  <box-model title="农技课堂">
    <template v-slot:content>
      <div class="next flex-y-center" @click="getIotEduWikipediaEvent">
        <img class="n-img" src="../../assets/img/select/reflesh.png" />
        <span>换一换</span>
      </div>
      <div v-if="!list.length" class="c-list no-data-sty">暂无数据</div>
      <div v-else class="c-list">
        <div v-for="(item, index) in list" :key="index" class="c-item">
          <div class="ci-title flex-y-center">
            <img class="img" src="../../assets/img/nj-tag.png" />
            <span>{{ item.eduWikipediaList[0].title }}</span>
          </div>
          <div class="ci-content">
            <span>{{ item.eduWikipediaList[0].content }}</span>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>

<script>
import { getIotEduWikipedia } from "@/api/index";
export default {
  data() {
    return {
      list: [],
      current: 1,
      hasMore: false
    }
  },
  components: {
    "box-model": () => import("../../components/common/Model.vue")
  },
  mounted() {
    this.getIotEduWikipediaEvent();
  },
  methods: {
    getIotEduWikipediaEvent(){
      if(this.hasMore){
        this.current = this.current + 1;
      } else {
        this.current = 1;
      }
      getIotEduWikipedia({
        current: this.current,
        size: 4
      }).then((res) => {
        const result = res.data;
        this.list = result.records;
        if(this.current < result.pages){
          this.hasMore = true;
        } else {
          this.hasMore = false;
        }
      })
    }
  }
}
</script>
  
<style scoped lang="less">
  .next {
    position: absolute;
    top: -10px;
    right: 20px;
    height: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #38EAFF;
    cursor: pointer;
    .n-img {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
  .c-list {
    position: relative;
    width: 100%;
    height: 428px;
    overflow-y: scroll;
    .c-item {
      position: relative;
      width: 100%;
      margin-bottom: 28px;
      .ci-title {
        width: 100%;
        height: 40px;
        background: rgba(40,136,241,0.1412);
        font-size: 16px;
        font-weight: 700;
        color: #4ADDFF;
        padding: 0 10px;
        .img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      }
      .ci-content {
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        margin-top: 10px;
      }
    }
    .c-item:last-child {
      margin-bottom: 0;
    }
  }
</style>